import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, BoxHeader, BoxBody, SeeMore, SeeMoreEllipsis, SeeMoreText } from './VHInfoPreviewBox.styled';

/**
 * @type {React.FC<{
 *  title: string;
 *  description: string;
 *  onSeeMoreClick?: () => void;
 * }>}
 * */
const VHInfoPreviewBox = ({ title, description, onSeeMoreClick }) => {
  const descriptionRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    if (descriptionRef.current) {
      setIsOverflowing(
        descriptionRef.current.scrollHeight >
          descriptionRef.current.clientHeight
      );
    }
  }, []);

  return (
    <Box>
      <BoxHeader>{title}</BoxHeader>
      <BoxBody ref={descriptionRef}>{description}</BoxBody>
      {isOverflowing && (
        <SeeMore onClick={onSeeMoreClick}>
          <SeeMoreEllipsis>...</SeeMoreEllipsis>
          <SeeMoreText>see more</SeeMoreText>
        </SeeMore>
      )}
    </Box>
  );
};

export default VHInfoPreviewBox;
